var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"missions-aside-layout"},[_c('div',{staticClass:"missions-aside-layout__content"},[_vm._t("header"),_c('div',{staticClass:"missions-aside-layout__content__body"},[_vm._t("default")],2)],2)])}
var staticRenderFns = []

export { render, staticRenderFns }